module.exports = __webpack_public_path__ + "static/media/goodnest@2x.dcb79a93.jpg";